<template>
  <div class="wrapper">
    <HeaderNav :auth="$store.state.isAuth"></HeaderNav>
    <div class="container">
      <h1 class="title__wrap">Введите ФИО, номер телефона и выберите банк.</h1>

      <div class="phone__wrap">
        <v-text-field
          full-width
          v-model="lastName"
          :rules="[rules.requiredLastName]"
          placeholder="Иванов"
          label="Фамилия"
          outlined
          clearable
          dense
        >
        </v-text-field>

        <v-text-field
          full-width
          v-model="firstName"
          :rules="[rules.requiredFirstName]"
          placeholder="Иван"
          label="Имя"
          outlined
          clearable
          dense
        >
        </v-text-field>

        <v-text-field
          full-width
          v-model="patronymic"
          :rules="[rules.requiredPatronymic]"
          placeholder="Иванович"
          label="Отчество"
          outlined
          clearable
          dense
        >
        </v-text-field>

        <v-text-field
          full-width
          v-model="phone"
          :rules="[rules.requiredPhone]"
          placeholder="+7 (000) 000-00-00"
          v-mask="'+7 (###) ###-##-##'"
          label="Телефон"
          outlined
          clearable
          dense
        >
        </v-text-field>

        <div class="bank-check">
          <v-autocomplete
            v-model="selectedBank"
            :items="filteredBankList"
            :loading="isLoadingBank"
            :search-input.sync="bankSearch"
            item-text="name_rus"
            item-value="id"
            label="Выберите банк"
            outlined
            dense
            no-filter
            clearable
            @update:search-input="filterBanks"
            no-data-text="Банков не найдено"
          >
          </v-autocomplete>
          <p class="bank-hint">Для выплаты через Систему быстрых платежей (СБП) выберите банк, к которому привязан ваш номер телефона.</p>
        </div>
      </div>

      <p class="politic">
        В случае победы эти данные понадобятся для вручения приза.<br />
        Обратите внимание, что изменить номер телефона и банк будет невозможно!
      </p>
      <v-btn block class="next-btn" :disabled="!isFormValid" :loading="isSending" @click="registerUser"> Далее </v-btn>
      <v-snackbar :transition="'slide-y-transition'" text-color="white" color="#C62828" top timeout="3000" v-model="snackbar">
        Этот номер телефона уже зарегистрирован
      </v-snackbar>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import HeaderNav from "@/components/HeaderNav.vue";

export default {
  components: { HeaderNav },
  data() {
    return {
      phone: "",
      firstName: "",
      lastName: "",
      patronymic: "",
      selectedBank: null,
      bankList: [],
      filteredBankList: [],
      bankSearch: "",
      isLoadingBanks: false,

      isLoading: false,
      isSending: false,
      rules: {
        requiredPhone: this.phoneRules,
        requiredFirstName: this.firstNameRules,
        requiredLastName: this.lastNameRules,
        requiredPatronymic: this.patronymicRules,
      },
      snackbar: false,
    };
  },
  computed: {
    isFormValid() {
      return (
        this.rules.requiredPhone() === true &&
        this.rules.requiredFirstName() === true &&
        this.rules.requiredLastName() === true &&
        this.rules.requiredPatronymic() === true &&
        this.selectedBank
      );
    },
  },
  methods: {
    async fetchBanks() {
      try {
        this.isLoadingBanks = true;
        const { data } = await axios.get(`${process.env.VUE_APP_NT}/prostodar/get-bank-information`);
        this.bankList = data.data || [];
        this.filteredBankList = [...this.bankList];
      } catch (error) {
        console.error("Ошибка при загрузке банков:", error);
      } finally {
        this.isLoadingBanks = false;
      }
    },

    filterBanks(search) {
      if (!search) {
        this.filteredBankList = [...this.bankList];
        return;
      }

      const searchLower = search.toLowerCase();
      this.filteredBankList = this.bankList.filter((bank) => bank.name_rus.toLowerCase().includes(searchLower));
    },

    phoneRules() {
      const pattern = /^\+\d \(\d{3}\) \d{3}-\d{2}-\d{2}$/;

      if (!this.phone) return "Укажите ваш телефон";
      if (!pattern.test(this.phone)) return "Укажите действительный номер телефона";

      return true;
    },

    firstNameRules() {
      const pattern = /^[А-ЯЁа-яё]{2,20}$/;

      if (!this.firstName) return "Введите имя";
      if (!pattern.test(this.firstName)) return "Неверный формат имени (прим: Иван)";

      return true;
    },
    lastNameRules() {
      const pattern = /^[А-ЯЁа-яё]{2,36}(-[А-ЯЁа-яё]{2,20})?$/;

      if (!this.lastName) return "Введите фамилию";
      if (!pattern.test(this.lastName)) return "Неверный формат фамилии (прим: Иванов)";

      return true;
    },
    patronymicRules() {
      const pattern = /^[А-ЯЁа-яё]{2,36}(-[А-ЯЁа-яё]{2,20})?$/;

      if (!this.patronymic) return true;
      if (!pattern.test(this.patronymic)) return "Неверный формат отчества (прим: Иванович)";

      return true;
    },
    async registerUser() {
      try {
        this.isSending = true;

        const payload = {
          email: this.$store.state.registerEmail,
          password: this.$store.state.registerPassword,
          fio: [this.lastName, this.firstName, this.patronymic].filter(Boolean).join(" "),
          phone: this.phone,
          operator: "other",
          bankId: this.selectedBank,
        };

        const { data } = await axios.post(`${process.env.VUE_APP_MYHOST}`, payload);

        this.$store.commit("isAcitvetedUser", false);
        this.$store.commit("changeEmail", this.$store.state.registerEmail);
        this.$store.commit("changeIsAuth", true);
        this.$cookies.set("cng_token", data.jwt);
        this.$router.push({ name: "LcMain" }).catch(() => {});
      } catch (error) {
        this.snackbar = true;
        this.phone = "";
        console.error(error.message);
      } finally {
        this.isSending = false;
      }
    },
  },
  mounted() {
    if (!this.$store.state.registerEmail || !this.$store.state.registerPassword) this.$router.push({ name: "login" }).catch(() => {});
    this.fetchBanks();
  },
};
</script>

<style scoped>
.container {
  padding: 30px;
}

.title__wrap {
  font: 700 30px "PT Sans";
  text-align: center;
  line-height: 110%; /* 44px */
  letter-spacing: -0.2px;
  color: black;
  text-wrap: balance;
}

.politic {
  font: 400 12px "Inter";
  font-style: normal;
  line-height: 130%;
  text-align: center;
  letter-spacing: -0.015em;
  padding-bottom: 5px;
  text-wrap: balance;
  color: black;
}

.bank-hint {
  font-size: 12px;
  color: black;
  margin-top: -15px;
  margin-bottom: 25px !important;
  text-align: center;
}
.bank-check {
  margin-top: 15px;
}

@media screen and (max-width: 4000px) and (min-width: 769px) {
  .wrapper {
    padding: 0 15px;
    display: flex;
    justify-content: center;
  }

  .container {
    max-width: 800px;
    width: 100%;
    padding: 80px;
  }

  .phone__wrap {
    width: 100%;
  }
}
</style>
